<template>
  <div
    class="videos-filter-picker"
    :class="{ 'max-width': fullWidth }"
    @click="openVideosFilterModal"
  >
    <div class="label-row">
      <v-icon size="16" color="#7283F3">panda-video</v-icon>
      <span class="label-text body-regular-small">{{ pickerLabel }}</span>
    </div>
    <v-icon size="16" :color="$vuetify.theme.dark ? '#757BA3' : '#8F92A3'"
      >panda-chev-down</v-icon
    >
    <videos-filter-modal
      v-model="showVideosFilterModal"
      @hasFilterApplied="(val) => (hasFilterApplied = val)"
      @appliedFilterText="(val) => (appliedFilterText = val)"
      @filterAll="(val) => (filterAll = val)"
      @confirmed="confirmFilter"
      @cancelFilter="cancelFilter"
    />
  </div>
</template>

<script>
import VideosFilterModal from './Modal/VideosFilterModal.vue'

export default {
  name: 'VideosFilterPicker',
  components: {
    VideosFilterModal,
  },
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showVideosFilterModal: false,
      hasFilterApplied: false,
      appliedFilterText: '',
      filterAll: false,
      lastConfirmedVideos: [],
      shouldRestoreOnOpen: false,
    }
  },
  computed: {
    pickerLabel() {
      if (this.filterAll || !this.hasFilterApplied)
        return this.$t('message.pages.analyticsV3.videosFilter.picker.label')
      return this.appliedFilterText
    },
  },
  methods: {
    openVideosFilterModal() {
      // Se deve restaurar, emite evento para restaurar seleção antes de abrir
      if (this.shouldRestoreOnOpen) {
        this.$emit('restoreSelectedVideos', this.lastConfirmedVideos)
        this.shouldRestoreOnOpen = false
      }
      this.showVideosFilterModal = true
      this.$root.$emit('openVideosFilterModal')
    },
    confirmFilter() {
      // Ao confirmar, salva o estado atual como confirmado
      this.$emit('getCurrentSelectedVideos', (videos) => {
        this.lastConfirmedVideos = JSON.parse(JSON.stringify(videos))
      })
    },
    cancelFilter() {
      // Ao cancelar, marca para restaurar na próxima abertura
      this.shouldRestoreOnOpen = true
    },
  },
}
</script>

<style lang="scss" scoped>
.videos-filter-picker {
  display: flex;
  flex: 1 0 0;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  padding: $spacing-03;
  border: 1px solid varFigma(neutral-95-lightest);
  border-radius: $spacing-02;
  cursor: pointer;
  transition: box-shadow 0.25s;
}

.videos-filter-picker:hover {
  box-shadow: 0 0 0 1px varFigma(brand-60-base) !important;
}

.max-width {
  max-width: 100%;
}
.dropdown-as-modal:hover {
  box-shadow: 0 0 0 2px rgba(63, 85, 238, 0.2);
}
.label-row {
  display: flex;
  align-items: center;
  gap: $spacing-03;
  flex: 1 0 0;
}
.label-text {
  color: varFigma(neutral-20-dark);
}
</style>
